document.addEventListener('DOMContentLoaded', () => {
  // Only run on relevant.html
  if (!window.location.pathname.includes('relevant')) {
    return;
  }

  const hypercolors = [
    '#FF00FF', // Magenta
    '#00FFFF', // Cyan
    '#FF1493', // Deep Pink
    '#39FF14', // Neon Green
    '#FF4500', // Orange Red
    '#FFFF00', // Yellow
    '#FF69B4', // Hot Pink
    '#1E90FF', // Dodger Blue
    '#7FFF00', // Chartreuse
    '#FF1493', // Deep Pink
    '#00FFFF', // Cyan
    '#FF00FF'  // Magenta
  ];

  let colorOffset = 0;

  fetch('assets/img/squirrel-teacup.svg')
    .then(response => response.text())
    .then(svgText => {
      const container = document.querySelector('.teacup-container');

      const parser = new DOMParser();
      const svgDoc = parser.parseFromString(svgText, 'image/svg+xml');

      container.innerHTML = '';
      container.appendChild(svgDoc.documentElement);

      // Query paths AFTER adding SVG to DOM, and look inside groups
      const layer2Paths = document.querySelectorAll('#Layer_2 g path');
      const layer3Paths = document.querySelectorAll('#Layer_3 g path');

      if (!layer2Paths.length || !layer3Paths.length) {
        console.error('Could not find SVG layers');
        return;
      }

      // Update colors immediately on load
      updateColors(layer2Paths, layer3Paths, 0, 0);

      // Handle scroll events with requestAnimationFrame
      let lastScrollY = 0;

      const handleScroll = () => {
        const scrollHeight = Math.max(
          document.body.scrollHeight,
          document.documentElement.scrollHeight
        ) - window.innerHeight;

        const scrollPercent = lastScrollY / scrollHeight;

        const layer2Index = Math.floor(scrollPercent * (hypercolors.length * 8) + colorOffset);
        const layer3Index = Math.floor((1 - scrollPercent) * (hypercolors.length * 5) + colorOffset);

        updateColors(layer2Paths, layer3Paths, layer2Index, layer3Index);
        requestAnimationFrame(handleScroll);
      };

      window.addEventListener('scroll', () => {
        lastScrollY = window.scrollY;
      });

      requestAnimationFrame(handleScroll);

      // Handle mouse movement
      document.addEventListener('mousemove', (e) => {
        const mouseX = e.clientX / window.innerWidth;
        const mouseY = e.clientY / window.innerHeight;

        const layer2Index = Math.floor(mouseX * (hypercolors.length * 4) + colorOffset);
        const layer3Index = Math.floor(mouseY * (hypercolors.length * 3) + colorOffset);

        updateColors(layer2Paths, layer3Paths, layer2Index, layer3Index);
        colorOffset += 0.1;
      });

      function updateColors(layer2Paths, layer3Paths, index2, index3) {
        const layer2Color = hypercolors[Math.abs(index2) % hypercolors.length];
        const layer3Color = hypercolors[Math.abs(index3) % hypercolors.length];

        layer2Paths.forEach(path => path.style.fill = layer2Color);
        layer3Paths.forEach(path => path.style.fill = layer3Color);
      }
    })
    .catch(error => {
      console.error('Error loading SVG:', error);
    });
});